<template>
  <div class="list-of-order">
    <template v-if="Object.keys(order).length">
      <div class="media" @click="getOrderDetailsInMobileView(order)">
        <div class="restourant-icon" v-if="brand">
          <img :src="brand.goorder_logo" alt="" />
        </div>
        <div class="media-body">
          <h6>
            {{ _T('Restaurant') }}
            <span class="badge" :class="orderBagde">
              {{ _T('Delivery Order') }}
            </span>
          </h6>
          <div class="d-sm-block d-none" v-if="!isScheduled">
            <label
              >{{ _T('Date &amp; Time :') }}
              <span>{{ orderDate(order.real_created_datetime) }}</span></label
            >
            <label
              >{{ _T('Brand Name:') }} <span>{{ brand.name }}</span></label
            >
            <label
              >{{ _T('Total:')
              }}<span>{{
                order.currency + ' ' + Num.price(totalAmount)
              }}</span></label
            >
          </div>
          <ul v-else>
            <li>
              <label>{{ _T('Date &amp; Time') }}</label>
              <span>{{
                isScheduled
                  ? orderDate(order.future_order_datetime)
                  : orderDate(order.real_created_datetime)
              }}</span>
            </li>
            <li>
              <label>{{ _T('Id') }}</label>
              <span>{{ order._id }}</span>
            </li>
            <li>
              <label>{{ _T('Total') }}</label>
              <span>{{ order.currency + ' ' + Num.price(totalAmount) }}</span>
            </li>
          </ul>
          <div class="d-sm-none" :class="{ 'd-none': isScheduled }">
            <label>{{ _T('Delivering your food') }}</label>
            <ul>
              <li><i class="fas fa-circle"></i></li>
              <li>
                <img src="/images/svg/global/clock.svg" />
                {{
                  isScheduled
                    ? orderDate(order.future_order_datetime)
                    : orderDate(order.real_created_datetime)
                }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="order-check-btns d-sm-block d-none">
        <btn-order-details
          :class-name="'btn btn-solid'"
          :order-id="order._id"
          :store-id="order.store_id"
          :brand-id="order.brand_id"
          route-name="order"
        />
      </div>
    </template>
    <template v-else>
      <h5>
        {{ _T('No order data found') }}
      </h5>
    </template>
  </div>
</template>
<script>
import * as utils from '@/utils/main_utils'
import BtnOrderDetails from './Buttons/ButtonOrderDetails'
import { mapGetters } from 'vuex'
import * as CONST from '@/constants'
import Windowsize from '@/mixins/Windowsize'
export default {
  props: {
    order: {
      type: Object,
      default() {
        return {}
      },
    },
    isScheduled: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [Windowsize],
  components: {
    BtnOrderDetails,
  },
  computed: {
    orderBagde() {
      switch (this.order && this.order.order_status) {
        case CONST.ORDER_STATUS_IN_PROGRESS:
        case CONST.ORDER_STATUS_READY:
          return 'badge-delivered'
        case CONST.ORDER_STATUS_ON_A_WAY_TO_FINISH:
          return 'badge-delayed'
        default:
          return 'badge-delivered'
      }
    },
    totalAmount() {
      if (this.order) {
        return (
          (parseFloat(this.order.tip_amount) || 0) +
          parseFloat(this.order.balance_due)
        )
      }
      return 0
    },
    ...mapGetters(['_T', 'find_brand_by_main_id', 'brandStoreRoute']),
    brand() {
      if (this.order) {
        return this.find_brand_by_main_id(this.order.brand_id)
      }
      return {}
    },
  },
  methods: {
    orderDate(date) {
      if (date) {
        return utils.datetime_in_local_timezone(date)
      }
    },
    getOrderDetailsInMobileView(order) {
      if (this.windowSize > 575) {
        return
      }

      this.$router.push(
        `order/${order.brand_id}/${order.store_id}/${order._id}`
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.body-rtl {
  .list-of-order {
    .media {
      .media-body {
        text-align: right;
        margin-right: 1.25rem;
      }
    }
  }
}
.badge-delivered,
.delivered-title {
  background-color: $color-tertiary-1;
  color: $color-tertiary;
}

.badge-cancle {
  background-color: $color-primary-1;
  color: $color-primary;
}

.badge-process,
.dining-title {
  background-color: $color-secondary-1;
  color: $color-secondary;
}

.badge-delayed,
.carry-title {
  background-color: $warning-color-background;
  color: $warning-color;
}

.list-of-order {
  display: flex;
  justify-content: space-between;
  padding: $px20 $px10;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }

  + .list-of-order {
    border-top: $px1 solid $light-border;
  }

  .media {
    .restourant-icon {
      width: $px64;
      height: $px64;
      border: $px1 solid $light-border;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: $px28;
        height: auto;
      }
    }

    .media-body {
      margin-left: $px20;

      h6 {
        font-weight: 600;
        line-height: $px22;
        letter-spacing: 0.005em;
        margin-bottom: $px10;

        .badge {
          font-weight: 600;
          font-size: $px10;
          line-height: $px11;
          letter-spacing: 0.5px;
          padding: $px6 $px10;
        }
      }

      label {
        display: block;
        font-size: $px12;
        line-height: $px15;

        &:last-child {
          margin-bottom: 0;
        }
      }

      span {
        font-weight: 600;
        letter-spacing: 0.5px;
        font-size: $px12;
        line-height: $px15;
      }

      ul {
        li {
          padding: 0 $px14;
          border-left: $px1 solid $light-border;
          border-right: $px1 solid $light-border;

          label {
            margin-bottom: 0;
          }

          &:first-child {
            border-left: none;
            padding-left: 0;
          }

          &:last-child {
            border-right: none;
            padding-right: 0;
          }
        }
      }
    }
  }

  .order-check-btns {
    .btn {
      width: $px140;
      padding: $px10;

      + .btn {
        margin-left: $px6;
      }

      svg {
        vertical-align: sub;
      }
    }

    .btn-teritary {
      &:hover,
      &:focus {
        svg {
          path {
            fill: $color-tertiary;
          }
        }
      }
    }

    .btn-solid {
      &:hover,
      &:focus {
        /deep/ svg {
          path {
            fill: $color-primary;
          }
        }
      }
    }
  }
}
@media (max-width: 1199px) {
  .list-of-order {
    .media {
      .restourant-icon {
        transform: scale(0.9);
      }
    }
  }
}
@media (max-width: 991px) {
  .list-of-order {
    display: block;
    .order-check-btns {
      text-align: right;
      margin-top: $px15;
    }
    .media {
      .media-body {
        ul {
          li {
            display: block;
            padding: 0;
            border: none;
            + li {
              margin-top: $px10;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .list-of-order {
    .media {
      .restourant-icon {
        border-radius: $px20;
        transform: scale(0.8);
      }
      .media-body {
        margin-left: $px10;
        ul {
          li {
            display: inline-block;
            font-size: $px12;
            line-height: $px15;
            color: $light-font;
            i {
              font-size: $px3;
              vertical-align: middle;
            }
            + li {
              margin-top: 0;
              margin-left: $px4;
            }
            img {
              vertical-align: sub;
              margin-right: $px4;
            }
            &:first-child {
              img {
                width: $px14;
              }
            }
          }
        }
        label {
          font-weight: normal;
          font-size: $px13;
          line-height: $px16;
          letter-spacing: 0.005em;
        }
        h6 {
          margin-bottom: 0;
          .badge {
            border-radius: $px14;
            font-size: $px13;
            float: right;
          }
        }
      }
    }
    > ul {
      text-align: right;
      margin-top: $px26;
      li {
        img {
          width: $px18;
          vertical-align: text-bottom;
        }
        &:first-child {
          a {
            color: $color-tertiary;
          }
        }
        + li {
          margin-left: $px30;
        }
      }
    }
  }
}
</style>
